export enum TimeOut {
	CLOSE_BRAND_DEFAULT = 200,
	HOVER_OUTSIDE = 210,
	BACK_ACTION = 100,
}
